import { ErrorHandler, Injectable, Optional } from '@angular/core';

import { IPSObservabilityService } from '@ips/common-angular';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
	constructor(@Optional() private readonly observability: IPSObservabilityService) {}
	handleError(error: unknown) {
		if (!environment.production) {
			console.error(error);
			return;
		}
		
		if (error instanceof Error) {
			this.observability?.error(error);
		}
		// Could disable for prod
		console.error(error);
	}
}
